<template>
  <b-button id="submitButton" size="sm" variant="success">{{name}}</b-button>
</template>
<script>
export default {
  name: 'AddButton',
  data () {
    return {
      name: null
    }
  },
  props: {
    title: {
      type: String,
      default: null,
      description: 'Buton title bilgisi'
    }
  },
  mounted () {
    this.name = this.title ? this.title : this.$t('header.save')
  }
}

</script>



// WEBPACK FOOTER //
// src/components/AddButton.vue